// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:17
import { EngagementResourceType_abstract } from './../abstract/SagaSchema/EngagementResourceType_abstract';
export class EngagementResourceType extends EngagementResourceType_abstract {}
